<ng-template #displayTemplateRef
             let-cellData
             let-rowData="rowData">
  <a (click)="invokeAction(rowData, cellData)">
    <i [class]="iconClass"></i>
  </a>
</ng-template>